<template>
  <form>
    <md-card>
      <md-card-header
        class="md-card-header-icon"
        :class="getClass(headerColor)"
      >
        <div class="card-icon">
          <md-icon>contact_support</md-icon>
        </div>
        <h4 class="title">
          Support Subscription
        </h4>
      </md-card-header>
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-size-100" v-if="status === 'Cancelled'">
            <md-button
              class="md-success"
              @click="status = 'Active'"
              data-tour="add_a_support_plan"
            >
              Add a Support Plan
            </md-button>
          </div>
          <div class="md-layout-item md-size-100" v-if="status === 'Active'">
            <div class="ls-status-block">
              <label>Status</label><br />
              <badge :type="getBadgeType(status)" data-tour="status">{{
                status
              }}</badge>
            </div>
            <md-field>
              <label>Next Billing Date</label>
              <md-input
                v-model="nextBillingDate"
                disabled
                data-tour="next_billing_date"
              ></md-input>
            </md-field>
            <md-field>
              <label>Plan Name</label>
              <md-input
                v-model="planName"
                disabled
                data-tour="plan_name"
              ></md-input>
            </md-field>
            <md-field>
              <label>Forum Support</label>
              <md-input
                v-model="forumSupport"
                disabled
                data-tour="forum_support"
              ></md-input>
            </md-field>
            <md-field>
              <label>Documentation Access</label>
              <md-input
                v-model="documentationAccess"
                disabled
                data-tour="documentation_access"
              ></md-input>
            </md-field>
            <md-field>
              <label>Download New Releases</label>
              <md-input
                v-model="downloadNewReleases"
                disabled
                data-tour="download_new_releases"
              ></md-input>
            </md-field>
            <md-field>
              <label>Email Support</label>
              <md-input
                v-model="emailSupport"
                disabled
                data-tour="email_support"
              ></md-input>
            </md-field>
            <md-field>
              <label>Guaranteed Response Time</label>
              <ul
                class="ls-response-time-list"
                data-tour="guaranteed_response_time"
              >
                <li v-for="item in guaranteedResponseTime" :key="item">
                  {{ item }}
                </li>
              </ul>
            </md-field>
            <md-field>
              <label>Weekday Business Hours Triage</label>
              <md-input
                v-model="triageHours"
                disabled
                data-tour="weekday_bussiness_hours_triage"
              ></md-input>
            </md-field>
            <md-field>
              <label>24/7 Triage</label>
              <md-input
                v-model="fullTriage"
                disabled
                data-tour="24/7_triage"
              ></md-input>
            </md-field>
            <md-field>
              <label>Phone Support</label>
              <md-input
                v-model="phoneSupport"
                disabled
                data-tour="phone_support"
              ></md-input>
            </md-field>
            <md-field>
              <label>Personalized Code Reviews</label>
              <md-input
                v-model="personalizedCodeReviews"
                disabled
                data-tour="personalized_code_reviews"
              ></md-input>
            </md-field>
            <md-field>
              <label>Named Support Engineer</label>
              <md-input
                v-model="namedSupportEngineer"
                disabled
                data-tour="named_support_engineer"
              ></md-input>
            </md-field>
            <md-button
              class="md-danger"
              @click="status = 'Cancelled'"
              data-tour="cancel_suport"
            >
              Cancel Support
            </md-button>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </form>
</template>
<script>
import { Badge } from "@/components";
export default {
  components: {
    Badge
  },
  props: {
    headerColor: {
      type: String,
      default: ""
    }
  },
  methods: {
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    },
    getBadgeType: function(status) {
      switch (status) {
        case "In Trial":
          return "info";
        case "Active":
          return "success";
        case "Cancelled":
        case "None":
          return "danger";
        default:
          return "info";
      }
    }
  },
  data() {
    return {
      status: "Active",
      nextBillingDate: "18-May-2020",
      planName: "GROWTH PLAN (Monthly)",
      forumSupport: "Yes",
      documentationAccess: "Yes",
      downloadNewReleases: "Yes",
      emailSupport: "Yes",
      guaranteedResponseTime: ["P1: 24h", "P2: 48h", "P3: 72h"],
      triageHours: "Yes (Pacific Time Zone)",
      fullTriage: "No",
      phoneSupport: "No",
      personalizedCodeReviews: "No",
      namedSupportEngineer: "No"
    };
  }
};
</script>
<style type="scss" scoped>
.ls-response-time-list {
  list-style: none;
  padding-left: 0px;
  padding-top: 15px;
}
</style>
